"use client"

import { useContext } from "react"
import OfferingPageContent from "@/components/Offering2"
import { SlideContext } from "@/context/SlideContent"
import { Offering } from "@/models/Offering"
import { Provider } from "@/models/Provider"
import { Price } from "@/models/Price"
import { RenderedTerm } from "@/models/renderedTerm"

export default function ProviderPlan({
  offering,
  override,
  provider,
  price,
  renderedTerms,
}: {
  offering: Offering
  override?: string | undefined
  provider: Provider
  price: Price
  renderedTerms?: RenderedTerm[]
}) {
  const { context, setContext } = useContext(SlideContext)

  return (
    <OfferingPageContent
      onClick={(isFuture = false) =>
        setContext({
          open: !context.open,
          offering,
          provider,
          override,
          price,
          isFuture,
        })
      }
      renderedTerms={renderedTerms}
      provider={provider}
      offering={offering}
    />
  )
}
